import { getOnboardingV1 } from '@/onboarding-homepage/api/onboarding-api';

const ONBOARDING_REDIRECT_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export async function fetchHasOnboardingAccess () {
    const response = await getOnboardingV1();
    const onboardingTask = response?.data;

    if (onboardingTask?.isComplete !== false || !onboardingTask.createdAt) {
        return false;
    }

    return Date.now() - onboardingTask.createdAt < ONBOARDING_REDIRECT_WINDOW_MS;
}
